import React, { useState } from 'react';
import './Signin.css';
import { FaEnvelope, FaLock,FaGoogle,FaGithub,FaEye,FaEyeSlash } from "react-icons/fa"; 
import { ToastContainer, toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';



const Signin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [showPassword, setShowPassword] = useState(false);
  const [toastId, setToastId] = useState(null); 
  const navigate = useNavigate();
  

  const handleSignIn = () => {
    navigate('/upload');
    if (!email || !password) {
      toast.error('Please fill all fields ❗', {
        position: 'bottom-center',
        autoClose: 3000,
      });
      return;
    }
    const id = toast.loading('Signing in...', {
      position: 'bottom-center',
    });
    setToastId(id);
    

  setTimeout(() => {
    console.log('Signing in with:', email, password);
    
    toast.update(id, {
      render: 'Login Successful ✅',
      type: 'success',
      isLoading: false,
      autoClose: 3000,
    });
  }, 2000);
};

  const handleForgotPassword = () => {
    // Navigate to Forgot Password page or handle reset
    toast.info('Redirecting to Forgot Password...', { position: 'bottom-center' });
  };

  const handleGoogleSignIn = () => {
    // Handle Google OAuth here
    //toast.info('Signing in with Google...', { position: 'bottom-center' });
      window.location.href =
      'https://accounts.google.com/o/oauth2/v2/auth?' +
      new URLSearchParams({
        client_id: 'YOUR_GOOGLE_CLIENT_ID',
        redirect_uri: 'http://localhost:3000/oauth2callback',  // your redirect URI
        response_type: 'token',  // or 'code' if using backend
        scope: 'email profile openid',
        include_granted_scopes: 'true',
        state: 'signin',
      }).toString();
  };

  const handleGitHubSignIn = () => {
    // Handle GitHub OAuth here
    //toast.info('Signing in with GitHub...', { position: 'bottom-center' });
    window.location.href =
    'https://github.com/login/oauth/authorize?' +
    new URLSearchParams({
      client_id: 'YOUR_GITHUB_CLIENT_ID',
      redirect_uri: 'http://localhost:3000/oauth2callback',  // your redirect URI
      scope: 'read:user user:email',
      state: 'github',
    }).toString();
  };

  const handleSignUp = () => {
    // Navigate to Sign Up page
    toast.info('Redirecting to Sign Up page...', { position: 'bottom-center' });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };


  return (
    <div className="sign-in-container">
      <h1>Sign In</h1>
      <div className="form-container">
      <div class="input-container">
      <FaEnvelope className="icon" />
        <input type="email" placeholder="Email" 
           value={email}
           onChange={(e) => setEmail(e.target.value)}
           
           />
        </div>

        <div class="input-container">
        <FaLock className="icon" />
        <input  type={showPassword ? 'text' : 'password'}  placeholder="Password" 
         value={password}
         onChange={(e) => setPassword(e.target.value)}/>
         <span className="password-toggle-icon" onClick={togglePasswordVisibility}>
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>
        <a href="/forgot-password" className="forgot-password"  onClick={handleForgotPassword}>Forgot Password?</a>
        <br/>
        <br/>
        <br/>

        <button className="sign-in-btn" onClick={handleSignIn}   disabled={!email || !password}
          title={!email || !password ? "Please enter email & password" : ""}> 
        
            Sign In
        
          </button>
        
        
        <div className="divider-container">
          <hr />
          <span>OR</span>
          <hr />
        </div>

        <div className="social-login">
          <button className="social-btn " onClick={handleGoogleSignIn}>
            <FaGoogle className="social-icon" />
            Sign in with Google</button>
          <button className="social-btn "  onClick={handleGitHubSignIn}>
             <FaGithub className="social-icon" />
          Sign in with GitHub</button>
        </div>

        <div className="sign-up-container">
        <p>Don't have an account? <Link to="/signup">Sign Up</Link></p>

        </div>
      </div>
      <ToastContainer /> 
    </div>
  );
};

export default Signin;